export const VisitorResponseType = {
  Name: 1,
  Phone: 2,
  Email: 3,
  Message: 4,
  Region: 5,
  Address: 6
};
